export const DARK_TEXT_CUSTOMER_IDS: string[] = ['demo', 'E42', 'E43', 'E44', 'E38'];
